// src/components/common/
import React from 'react';

const Heading = ({
  children,
  level = 2,
  align = 'left',
  color = 'default',
  className = '',
  withAccent = false,
  ...props
}) => {
  // Determine alignment classes
  const getAlignClasses = () => {
    switch (align) {
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
      case 'left':
      default:
        return 'text-left';
    }
  };
  
  // Determine color classes
  const getColorClasses = () => {
    switch (color) {
      case 'primary':
        return 'text-primary';
      case 'secondary':
        return 'text-secondary';
      case 'white':
        return 'text-white';
      case 'gradient':
        return 'text-gradient';
      case 'default':
      default:
        return '';
    }
  };
  
  // Combine all classes
  const headingClasses = `
    font-montserrat font-bold
    ${getAlignClasses()}
    ${getColorClasses()}
    ${className}
  `;
  
  // Create heading with accent line if withAccent is true
  const headingContent = withAccent ? (
    <div className={`relative ${align === 'center' ? 'flex flex-col items-center' : ''}`}>
      {children}
      <div className={`h-1 bg-secondary w-20 mt-4 ${align === 'right' ? 'ml-auto' : ''}`}></div>
    </div>
  ) : (
    children
  );
  
  // Render appropriate heading level
  switch (level) {
    case 1:
      return (
        <h1 className={`text-4xl md:text-5xl mb-6 ${headingClasses}`} {...props}>
          {headingContent}
        </h1>
      );
    case 3:
      return (
        <h3 className={`text-2xl md:text-3xl mb-4 ${headingClasses}`} {...props}>
          {headingContent}
        </h3>
      );
    case 4:
      return (
        <h4 className={`text-xl md:text-2xl mb-3 ${headingClasses}`} {...props}>
          {headingContent}
        </h4>
      );
    case 5:
      return (
        <h5 className={`text-lg md:text-xl mb-2 ${headingClasses}`} {...props}>
          {headingContent}
        </h5>
      );
    case 6:
      return (
        <h6 className={`text-base md:text-lg mb-2 ${headingClasses}`} {...props}>
          {headingContent}
        </h6>
      );
    case 2:
    default:
      return (
        <h2 className={`text-3xl md:text-4xl mb-5 ${headingClasses}`} {...props}>
          {headingContent}
        </h2>
      );
  }
};

export default Heading;